import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _parseInt from '@babel/runtime-corejs3/core-js/parse-int';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js/instance/includes';
import * as React from 'react';
import classNames from 'classnames';
import { ResizeSensor } from 'css-element-queries';
import { prependPrefix } from '../../utils/style.js';
import { Draggable } from './draggable.js';
import { css, on, off, isMobileView } from './utils.js';
import { normalizeWheelEvent } from './vendors/normalize-wheel-event.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var THUMB_MIN_SIZE = 10;
var LegacyScrollable = /*#__PURE__*/function (_React$Component) {
  _inherits(LegacyScrollable, _React$Component);

  var _super = _createSuper(LegacyScrollable);

  function LegacyScrollable(props) {
    var _this;

    _classCallCheck(this, LegacyScrollable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      if (_this.calcThumbSize() && _this.container.current) {
        // adjust thumb position
        var container = _this.container.current;
        var pos = container.scrollTop / (container.scrollHeight - container.offsetHeight);

        _this.setState({
          pos: pos
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
      if (e.button === 0) {
        _this.startDrag(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
      _this.startDrag(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragMove", function (e) {
      var pos = _this.getScrollPos(e);

      _this.doScroll(pos);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragEnd", function (e) {

      _this.draggable.dragEnd();

      _this.setState({
        dragging: false
      });

      var pos = _this.getScrollPos(e);

      _this.doScroll(pos);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseWheel", function (e) {
      // 若当前没有滚动条，不触发 onScroll，与 cssScrollbar 维持一致
      if (!_this.state.showScrollbar) {
        return false;
      }
      /* if (e.originalEvent) {
        e = e.originalEvent
      } */


      var container = _this.container.current;
      var content = _this.content.current;
      var pos = _this.state.pos;

      if (!container || !content) {
        return false;
      }

      var pageHeight = container.offsetHeight;
      var lineHeight = _parseInt(css(container, 'font-size')) || 10;
      var movableSize = content.offsetHeight - pageHeight;
      var normalizedEvent = normalizeWheelEvent(e, lineHeight, pageHeight);

      if (!normalizedEvent) {
        e.preventDefault();
        return false;
      }

      var deltaX = normalizedEvent.deltaX,
          deltaY = normalizedEvent.deltaY;

      if (deltaY === 0 && deltaX !== 0 || Math.abs(deltaY) <= 1 && Math.abs(deltaX) > 1) {
        _this.doScroll(pos - deltaX * lineHeight / movableSize, true);
      } else if (deltaX === 0 && deltaY !== 0 || Math.abs(deltaX) <= 1 && Math.abs(deltaY) > 1) {
        _this.doScroll(pos - deltaY * lineHeight / movableSize, true);
      }

      e.preventDefault();
      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "onScrollbarClick", function (e) {
      var thumb = _this.getThumb();

      if (!_this.state.showScrollbar || e.target === thumb) {
        return;
      }

      var direction = _this.props.direction;

      var _this$draggable$getEv = _this.draggable.getEventPos(e),
          left = _this$draggable$getEv.left,
          top = _this$draggable$getEv.top;

      var thumbOffset = thumb.getBoundingClientRect();
      var moveWay = 0;
      var thumbSize;

      if (direction === 'horizontal') {
        thumbSize = thumb.offsetWidth;

        if (left < thumbOffset.left) {
          moveWay = -1;
        } else if (left > thumbOffset.left + thumbSize) {
          moveWay = 1;
        }
      } else {
        thumbSize = thumb.offsetHeight;

        if (top < thumbOffset.top) {
          moveWay = -1;
        } else if (top > thumbOffset.top + thumbSize) {
          moveWay = 1;
        }
      }

      var DELTA = 0.1;

      if (moveWay < 0) {
        _this.doScroll(_this.state.pos - DELTA, true);
      } else if (moveWay > 0) {
        _this.doScroll(_this.state.pos + DELTA, true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onScroll", function () {
      // from react scroll
      if (_this.props.onScroll) {
        var container = _this.getContainer();

        var pos = container.scrollTop / (container.scrollHeight - container.offsetHeight);

        _this.props.onScroll(pos, container);
      }
    });

    _this.state = {
      active: false,
      pos: 0,
      startPos: 0,
      thumbSize: 0,
      dragging: false,
      showScrollbar: false
    };
    _this.container = /*#__PURE__*/React.createRef();
    _this.content = /*#__PURE__*/React.createRef();
    _this.thumb = /*#__PURE__*/React.createRef(); // custom scrollbar

    if (LegacyScrollable.cssScrollbar) {
      return _possibleConstructorReturn(_this);
    }

    _this.draggable = new Draggable(_this.onDragMove, _this.onDragEnd);
    return _this;
  }

  _createClass(LegacyScrollable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (LegacyScrollable.cssScrollbar) {
        return;
      }

      var container = this.getContainer();
      var content = this.getContent();
      this.resizable = new ResizeSensor([container, content], this.onResize);
      this.bindWheelEvent();
      this.calcThumbSize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (LegacyScrollable.cssScrollbar) {
        return;
      }

      if (this.resizable) {
        this.resizable.detach();
      }

      this.unbindWheelEvent();
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return this.container.current;
    }
  }, {
    key: "getContent",
    value: function getContent() {
      return this.content.current;
    }
  }, {
    key: "getThumb",
    value: function getThumb() {
      return this.thumb.current;
    }
  }, {
    key: "bindWheelEvent",
    value: function bindWheelEvent() {
      if (!this.content.current) {
        return;
      }

      on(this.content.current, 'mousewheel wheel DOMMouseScroll MozMousePixelScroll', this.onMouseWheel);
    }
  }, {
    key: "unbindWheelEvent",
    value: function unbindWheelEvent() {
      if (!this.content.current) {
        return;
      }

      off(this.content.current, 'mousewheel wheel DOMMouseScroll MozMousePixelScroll', this.onMouseWheel);
    }
  }, {
    key: "getScrollPos",
    value: function getScrollPos(e) {
      var pos = 0;
      var posPx = 0;
      var direction = this.props.direction;
      var startPos = this.state.startPos;
      var container = this.getContainer();
      var thumb = this.getThumb();
      var wrapOffset = container.getBoundingClientRect();

      var _this$draggable$getEv2 = this.draggable.getEventPos(e),
          left = _this$draggable$getEv2.left,
          top = _this$draggable$getEv2.top;

      var movableSize;
      var attr;

      if (direction === 'horizontal') {
        movableSize = container.offsetWidth - thumb.offsetWidth;
        posPx = left - startPos - wrapOffset.left;
        attr = 'left';
      } else {
        movableSize = container.offsetHeight - thumb.offsetHeight;
        posPx = top - startPos - wrapOffset.top;
        attr = 'top';
      }

      if (posPx < 0) {
        posPx = 0;
      } else if (posPx > movableSize) {
        posPx = movableSize;
      }

      pos = posPx / movableSize;
      css(thumb, attr, "".concat(posPx, "px"));
      return pos;
    }
  }, {
    key: "calcThumbSize",
    value: function calcThumbSize() {
      var content = this.getContent();
      var container = this.getContainer();
      var direction = this.props.direction;
      var viewport;
      var contentSize;
      var attr;

      if (direction === 'horizontal') {
        viewport = container.offsetWidth;
        contentSize = content.offsetWidth;
        attr = 'width';
      } else {
        viewport = container.offsetHeight;
        contentSize = content.offsetHeight;
        attr = 'height';
      }

      if (viewport >= contentSize) {
        this.setState({
          showScrollbar: false
        });
        return 0;
      }

      var thumb = this.getThumb();
      var viewableRatio = viewport / contentSize;
      var thumbSize = viewport * viewableRatio;

      if (thumbSize < THUMB_MIN_SIZE) {
        // limit min size
        thumbSize = THUMB_MIN_SIZE;
      } // TODO: clear old state


      css(thumb, attr, "".concat(thumbSize, "px"));

      if (this.state.pos) {
        this.moveThumb(this.state.pos);
      }

      this.setState({
        showScrollbar: true,
        thumbSize: thumbSize
      });
      return thumbSize;
    }
  }, {
    key: "startDrag",
    value: function startDrag(e) {
      this.draggable.startDrag();
      var direction = this.props.direction;
      var thumb = this.getThumb();
      var thumbOffset = thumb.getBoundingClientRect();

      var _this$draggable$getEv3 = this.draggable.getEventPos(e),
          left = _this$draggable$getEv3.left,
          top = _this$draggable$getEv3.top;

      var startPos;

      if (direction === 'horizontal') {
        startPos = left - thumbOffset.left;
      } else {
        startPos = top - thumbOffset.top;
      }

      this.setState({
        dragging: true,
        startPos: startPos
      });
    }
  }, {
    key: "moveThumb",
    value: function moveThumb(pos) {
      var direction = this.props.direction;
      var container = this.getContainer();
      var thumb = this.getThumb();
      var movableSize;
      var attr;

      if (direction === 'horizontal') {
        movableSize = container.offsetWidth - thumb.offsetWidth;
        attr = 'left';
      } else {
        movableSize = container.offsetHeight - thumb.offsetHeight;
        attr = 'top';
      }

      css(thumb, attr, "".concat(pos * movableSize, "px"));
    }
  }, {
    key: "doScroll",
    value: function doScroll(pos) {
      var move = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var moveToPos = pos;

      if (moveToPos > 1) {
        moveToPos = 1;
      } else if (moveToPos < 0) {
        moveToPos = 0;
      }

      if (this.state.pos === moveToPos) {
        return;
      }

      this.setState({
        pos: moveToPos
      });

      if (move) {
        this.moveThumb(moveToPos);
      }

      var container = this.getContainer();
      var content = this.getContent();
      var direction = this.props.direction;

      if (direction === 'horizontal') {
        container.scrollLeft = (content.offsetWidth - container.offsetWidth) * moveToPos;
      } else {
        container.scrollTop = (content.offsetHeight - container.offsetHeight) * moveToPos;
      }

      if (this.props.onScroll) {
        this.props.onScroll(moveToPos, container);
      }
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(pos) {
      var _this2 = this;

      if (LegacyScrollable.cssScrollbar) {
        var container = this.getContainer();
        var posPx = (container.scrollHeight - container.offsetHeight) * pos;
        container.scrollTop = posPx;
      } else {
        setTimeout(function () {
          // wait for calcThumbSize
          _this2.doScroll(pos, true);
        }, 60);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var scrollableCls = prependPrefix('scrollable');
      var directionCls = prependPrefix(this.props.direction || 'vertical');

      if (LegacyScrollable.cssScrollbar) {
        return /*#__PURE__*/React.createElement("div", {
          ref: this.container,
          id: this.props.id,
          className: classNames(scrollableCls, prependPrefix('css-scrollbar'), directionCls, this.props.className),
          onScroll: this.onScroll
        }, this.props.children);
      }

      var _this$state = this.state,
          dragging = _this$state.dragging,
          showScrollbar = _this$state.showScrollbar;
      return /*#__PURE__*/React.createElement("div", {
        id: this.props.id,
        className: classNames(scrollableCls, directionCls, this.props.className)
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.container,
        className: prependPrefix('wrap')
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.content,
        className: prependPrefix('content')
      }, this.props.children)), /*#__PURE__*/React.createElement("div", {
        className: classNames(prependPrefix('scrollbar'), (_classNames = {}, _defineProperty(_classNames, prependPrefix('active'), showScrollbar), _defineProperty(_classNames, prependPrefix('dragging'), dragging), _classNames)),
        onClick: this.onScrollbarClick
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.thumb,
        className: classNames([prependPrefix('thumb'), prependPrefix('draggable')]),
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onTouchStart
      })));
    }
  }], [{
    key: "init",
    value: function init() {
      var userAgent = window.navigator.userAgent; // macOS 使用 CSS 滚动条，不过当 ua 包含 Edge 时，代表非 chromium 内核，此时需要排除

      if (_includesInstanceProperty(userAgent).call(userAgent, 'AppleWebKit') && !_includesInstanceProperty(userAgent).call(userAgent, 'Edge')) {
        LegacyScrollable.cssScrollbar = true;
      }

      if (isMobileView()) {
        LegacyScrollable.cssScrollbar = true;
      }

      if (_includesInstanceProperty(userAgent).call(userAgent, 'Firefox')) {
        // 火狐不采用自定义样式的 scrollbar
        // 详情请参考 style/components/base/scrollable.scss
        LegacyScrollable.cssScrollbar = true;
      }
    }
  }]);

  return LegacyScrollable;
}(React.Component);

_defineProperty(LegacyScrollable, "cssScrollbar", false);

LegacyScrollable.init();

export { LegacyScrollable };
